import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer";

import { forgotPassword } from "../../../helpers/AuthType/authBackend";

export const userForgetPassword =
  (user: any, history: any) => async (dispatch: any) => {
    try {
      let response;
      if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
        response = forgotPassword({
          email: user.email,
        });
        console.log("-----------Response Forgot pwr------------------");
        console.log(user.email);
      }
      const data = await response;

      if (data) {
        dispatch(
          userForgetPasswordSuccess(
            "Reset link are sended to your mailbox, check there first"
          )
        );
      }
    } catch (forgetError) {
      dispatch(userForgetPasswordError(forgetError));
    }
  };
